module.exports = __webpack_public_path__ + "img/WhatsApp-GreenSquare-Logo.wine.b89981e8.svg";